import { createEmojiIcon } from '../EmojiIcon';

export const DeleteIcon = createEmojiIcon('🗑️');
export const DeleteOutlineIcon = createEmojiIcon('🗑️');
export const CloseIcon = createEmojiIcon('✕');
export const AddIcon = createEmojiIcon('➕');
export const EditIcon = createEmojiIcon('✏️');
export const SaveIcon = createEmojiIcon('💾');
export const VisibilityIcon = createEmojiIcon('👁️');
export const VisibilityOffIcon = createEmojiIcon('🙈');
export const ContentCopyIcon = createEmojiIcon('📋');
export const ExpandMoreIcon = createEmojiIcon('▼');
/** non-Icon-suffix alias for ExpandMoreIcon */
export const ExpandMore = createEmojiIcon('▼');
export const ExpandLessIcon = createEmojiIcon('▲');
export const HistoryIcon = createEmojiIcon('🕐');
export const RefreshIcon = createEmojiIcon('🔄');
export const SyncIcon = createEmojiIcon('🔄');
export const MoreVertIcon = createEmojiIcon('⋮');
export const RemoveIcon = createEmojiIcon('➖');
export const UndoIcon = createEmojiIcon('↩️');
export const RedoIcon = createEmojiIcon('↪️');
export const CheckIcon = createEmojiIcon('✓');
export const CheckCircleOutlineIcon = createEmojiIcon('⭕');
export const RadioButtonUncheckedIcon = createEmojiIcon('○');
export const SortIcon = createEmojiIcon('↕️');
export const SearchOffIcon = createEmojiIcon('🔇');
export const CodeIcon = createEmojiIcon('💻');
export const ImageIcon = createEmojiIcon('🖼️');
export const FolderIcon = createEmojiIcon('📁');
export const CircleIcon = createEmojiIcon('●');
export const CheckBoxIcon = createEmojiIcon('☑️');
export const CheckBoxOutlineBlankIcon = createEmojiIcon('☐');
export const IndeterminateCheckBoxIcon = createEmojiIcon('▣');
